// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"c9ceb39e","774":"17e13e0d","787":"39e4879f"}[chunkId] + ".chunk.js";
};